import { render, staticRenderFns } from "./select-send-message.vue?vue&type=template&id=acd48b0a&scoped=true&"
import script from "./select-send-message.vue?vue&type=script&lang=js&"
export * from "./select-send-message.vue?vue&type=script&lang=js&"
import style0 from "./select-send-message.vue?vue&type=style&index=0&id=acd48b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd48b0a",
  null
  
)

export default component.exports